(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artmypet-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-artmypet-home]');
    roots.forEach((root) => {
      const styleButtons = root.querySelectorAll('[data-style-note]');
      const styleNote = root.querySelector('[data-style-note-output]');

      styleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          styleButtons.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          if (styleNote) {
            styleNote.textContent = button.dataset.styleNote || '';
          }
        });
      });

      const stickyCta = root.querySelector('.amp-home__mobile-sticky');
      const updateStickyCta = () => {
        if (!stickyCta) return;
        stickyCta.classList.toggle('is-visible', window.innerWidth < 880 && window.scrollY > 520);
      };
      updateStickyCta();
      window.addEventListener('scroll', updateStickyCta, { passive: true });
      window.addEventListener('resize', updateStickyCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-portrait-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-pet-portrait-hero]');
    if (!roots.length) return;

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const money = (cents, currency) => {
      const amount = Number(cents || 0) / 100;
      const hasCents = Math.round(Number(cents || 0)) % 100 !== 0;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: hasCents ? 2 : 0,
        maximumFractionDigits: hasCents ? 2 : 0
      }).format(amount);
    };

    const variantValues = (variant) => variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
    const optionValue = (variant, optionName, optionNames) => {
      const names = optionNames || [];
      const values = variantValues(variant);
      const index = names.findIndex((name) => normalize(name) === normalize(optionName));
      return index >= 0 ? values[index] : '';
    };
    const formatAliases = {
      'rolled canvas': ['rolled canvas'],
      'gallery-wrapped canvas': ['gallery-wrapped canvas', 'wrapped canvas'],
      'black framed canvas': ['black framed canvas', 'black frame'],
      'natural wood framed canvas': ['natural wood framed canvas', 'natural framed canvas', 'wood frame'],
      'gold framed canvas': ['gold framed canvas', 'gold frame'],
      'black framed acrylic': ['black framed acrylic', 'black acrylic'],
      'gold framed acrylic': ['gold framed acrylic', 'gold acrylic']
    };
    const canonicalFormat = (value, sku = '') => {
      const normalized = normalize(value);
      if (normalize(sku).includes('rolled')) return 'Rolled Canvas';
      if (normalize(sku).includes('wrapped') || normalize(sku).includes('canvas-s')) return 'Gallery-Wrapped Canvas';
      if (normalize(sku).includes('framed-nat')) return 'Natural Wood Framed Canvas';
      if (normalize(sku).includes('framed-gld')) return 'Gold Framed Canvas';
      if (normalize(sku).includes('framed-blk') || normalize(sku).includes('black-s')) return 'Black Framed Canvas';
      if (normalize(sku).includes('acrylic-blk')) return 'Black Framed Acrylic';
      if (normalize(sku).includes('acrylic-gld')) return 'Gold Framed Acrylic';
      if (formatAliases['rolled canvas'].includes(normalized)) return 'Rolled Canvas';
      if (formatAliases['gallery-wrapped canvas'].includes(normalized)) return 'Gallery-Wrapped Canvas';
      if (formatAliases['black framed canvas'].includes(normalized)) return 'Black Framed Canvas';
      if (formatAliases['natural wood framed canvas'].includes(normalized)) return 'Natural Wood Framed Canvas';
      if (formatAliases['gold framed canvas'].includes(normalized)) return 'Gold Framed Canvas';
      if (formatAliases['black framed acrylic'].includes(normalized)) return 'Black Framed Acrylic';
      if (formatAliases['gold framed acrylic'].includes(normalized)) return 'Gold Framed Acrylic';
      return value || '';
    };
    const displayFormat = (format) => {
      const labels = {
        'Rolled Canvas': 'Rolled Canvas',
        'Gallery-Wrapped Canvas': 'Stretched Canvas',
        'Black Framed Canvas': 'Black Framed Canvas',
        'Natural Wood Framed Canvas': 'Natural Wood Framed Canvas',
        'Gold Framed Canvas': 'Gold Framed Canvas',
        'Black Framed Acrylic': 'Black Framed Acrylic',
        'Gold Framed Acrylic': 'Gold Framed Acrylic'
      };
      return labels[canonicalFormat(format)] || format;
    };
    const selectionsFromFormat = (format) => {
      const canonical = canonicalFormat(format);
      if (canonical === 'Black Framed Acrylic') return { material: 'Acrylic', canvasFinish: 'Framed', canvasColor: 'Black', acrylicColor: 'Black' };
      if (canonical === 'Gold Framed Acrylic') return { material: 'Acrylic', canvasFinish: 'Framed', canvasColor: 'Black', acrylicColor: 'Gold' };
      if (canonical === 'Gallery-Wrapped Canvas') return { material: 'Canvas', canvasFinish: 'Stretched', canvasColor: 'Black', acrylicColor: 'Black' };
      if (canonical === 'Natural Wood Framed Canvas') return { material: 'Canvas', canvasFinish: 'Framed', canvasColor: 'Natural', acrylicColor: 'Black' };
      if (canonical === 'Gold Framed Canvas') return { material: 'Canvas', canvasFinish: 'Framed', canvasColor: 'Gold', acrylicColor: 'Black' };
      if (canonical === 'Black Framed Canvas') return { material: 'Canvas', canvasFinish: 'Framed', canvasColor: 'Black', acrylicColor: 'Black' };
      return { material: 'Canvas', canvasFinish: 'Rolled', canvasColor: 'Black', acrylicColor: 'Black' };
    };
    const formatFromSelections = ({ material, canvasFinish, canvasColor, acrylicColor }) => {
      if (material === 'Acrylic') return acrylicColor === 'Gold' ? 'Gold Framed Acrylic' : 'Black Framed Acrylic';
      if (canvasFinish === 'Stretched') return 'Gallery-Wrapped Canvas';
      if (canvasFinish === 'Framed') {
        if (canvasColor === 'Natural') return 'Natural Wood Framed Canvas';
        if (canvasColor === 'Gold') return 'Gold Framed Canvas';
        return 'Black Framed Canvas';
      }
      return 'Rolled Canvas';
    };
    const variantFormat = (variant, optionNames) => canonicalFormat(
      optionValue(variant, 'Format', optionNames) || optionValue(variant, 'Style', optionNames),
      variant?.sku
    );

    roots.forEach((root) => {
      const configEl = root.querySelector('[data-pet-portrait-config]');
      if (!configEl) return;
      const config = JSON.parse(configEl.textContent);
      const uploadText = config.uploadText || {};
      const text = (key, fallback) => uploadText[key] || fallback;
      const sizesMigrated = config.variants.some((variant) => String(variant.sku || '').toUpperCase().endsWith('-0812'));
      const variantSize = (variant) => {
        const configuredSize = optionValue(variant, 'Size', config.optionNames);
        if (sizesMigrated) return configuredSize;
        const sku = String(variant?.sku || '').toUpperCase();
        if (sku.endsWith('-1218') || sku.endsWith('-S1218')) return '8 x 12 inch';
        if (sku.endsWith('-1421')) return '12 x 18 inch';
        if (sku.endsWith('-1827')) return '20 x 30 inch';
        return configuredSize;
      };
      const selectedVariant = config.variants.find((variant) => String(variant.id) === String(config.selectedVariantId)) ||
        config.variants.find((variant) => variant.sku === 'PP-ROLLED-0812') ||
        config.variants.find((variant) => variant.sku === 'PP-ROLLED-1218') ||
        config.variants[0];
      const selectedSize = variantSize(selectedVariant) || '8 x 12 inch';
      const selectedStyle = variantFormat(selectedVariant, config.optionNames) || 'Rolled Canvas';
      const selectedProduct = selectionsFromFormat(selectedStyle);
      const state = {
        artStyle: 'Watercolor',
        style: selectedStyle,
        size: selectedSize,
        material: selectedProduct.material,
        canvasFinish: selectedProduct.canvasFinish,
        canvasColor: selectedProduct.canvasColor,
        acrylicColor: selectedProduct.acrylicColor,
        pets: 1,
        rush: false,
        uploadLater: false,
        uploadedUrls: [],
        sourceFiles: [],
        preview: null,
        previewApproved: false,
        designerService: false,
        secondPortrait: null,
        wizardStep: 1,
        nameMode: 'none'
      };

      const els = {
        mainImage: root.querySelector('.amp-hero__image'),
        thumbs: root.querySelectorAll('.amp-hero__thumb'),
        artStyleButtons: root.querySelectorAll('[data-art-style-option]'),
        artStyleGroup: root.querySelector('[data-art-style-group]'),
        artStyleNote: root.querySelector('[data-art-style-note-output]'),
        artStyleScroller: root.querySelector('[data-art-style-scroller]'),
        artStylePrev: root.querySelector('[data-art-style-prev]'),
        artStyleNext: root.querySelector('[data-art-style-next]'),
        artStyleBackdrop: root.querySelector('[data-art-style-backdrop]'),
        artStyleClose: root.querySelector('[data-art-style-close]'),
        styleButtons: root.querySelectorAll('[data-style-option]'),
        sizeButtons: root.querySelectorAll('[data-size-option]'),
        sizeGroup: root.querySelector('[data-size-group]'),
        petButtons: root.querySelectorAll('[data-pet-count]'),
        rushToggle: root.querySelector('[data-rush-toggle]'),
        uploadLater: root.querySelector('[data-upload-later]'),
        fileInput: root.querySelector('[data-file-input]'),
        uploadDropzone: root.querySelector('[data-upload-dropzone]'),
        uploadStart: root.querySelector('[data-upload-start]'),
        uploadStartButton: root.querySelector('[data-upload-start-button]'),
        fileLabel: root.querySelector('[data-file-label]'),
        uploadList: root.querySelector('[data-upload-list]'),
        uploadStatus: root.querySelector('[data-upload-status]'),
        uploadProgress: root.querySelector('[data-upload-progress]'),
        uploadProgressLabel: root.querySelector('[data-upload-progress-label]'),
        uploadPercent: root.querySelector('[data-upload-percent]'),
        uploadMeter: root.querySelector('[data-upload-meter]'),
        uploadProgressFill: root.querySelector('[data-upload-progress-fill]'),
        photoContinue: root.querySelector('[data-photo-continue]'),
        variantInput: root.querySelector('[data-variant-id-input]'),
        propertyArtStyle: root.querySelector('[data-property-art-style]'),
        propertyPets: root.querySelector('[data-property-pets]'),
        propertyUpload: root.querySelector('[data-property-upload]'),
        photoProperties: root.querySelector('[data-photo-properties]'),
        form: root.querySelector('form[data-type="add-to-cart-form"]'),
        formErrorWrap: root.querySelector('.product-form__error-message-wrapper'),
        formError: root.querySelector('[data-form-error]'),
        submit: root.querySelector('[type="submit"]'),
        price: root.querySelector('[data-variant-price]'),
        compare: root.querySelector('[data-variant-compare]'),
        summaryArtStyle: root.querySelector('[data-summary-art-style]'),
        summaryFormat: root.querySelector('[data-summary-format]'),
        summarySize: root.querySelector('[data-summary-size]'),
        summarySizeRow: root.querySelector('[data-summary-size-row]'),
        summaryPets: root.querySelector('[data-summary-pets]'),
        summaryExtraRow: root.querySelector('[data-summary-extra-row]'),
        summaryExtraPets: root.querySelector('[data-summary-extra-pets]'),
        summaryRushRow: root.querySelector('[data-summary-rush-row]'),
        summarySecondRow: root.querySelector('[data-summary-second-row]'),
        summarySecondPrice: root.querySelector('[data-summary-second-price]'),
        summaryTotal: root.querySelector('[data-summary-total]'),
        deliveryCopy: root.querySelector('[data-delivery-copy]'),
        mobileAdd: root.querySelector('[data-mobile-add]'),
        mobileTotal: root.querySelector('[data-mobile-total]'),
        previewCreate: root.querySelector('[data-preview-create]'),
        previewName: root.querySelector('[data-preview-name]'),
        previewAccessories: root.querySelector('[data-preview-accessories]'),
        previewFeatures: root.querySelector('[data-preview-features]'),
        previewMessage: root.querySelector('[data-preview-message]'),
        previewLoading: root.querySelector('[data-preview-loading]'),
        previewSource: root.querySelector('[data-preview-source]'),
        previewStage: root.querySelector('[data-preview-stage]'),
        previewStageDetail: root.querySelector('[data-preview-stage-detail]'),
        previewProgress: root.querySelector('[data-preview-progress]'),
        previewElapsed: root.querySelector('[data-preview-elapsed]'),
        previewResult: root.querySelector('[data-preview-result]'),
        previewCanvas: root.querySelector('[data-preview-canvas]'),
        orderPreview: root.querySelector('[data-order-preview]'),
        orderMaterialButtons: root.querySelectorAll('[data-order-material]'),
        orderCanvasFinishButtons: root.querySelectorAll('[data-order-canvas-finish]'),
        orderCanvasColorButtons: root.querySelectorAll('[data-order-canvas-color]'),
        orderAcrylicColorButtons: root.querySelectorAll('[data-order-acrylic-color]'),
        canvasFinishControls: root.querySelector('[data-canvas-finish-controls]'),
        canvasFrameControls: root.querySelector('[data-canvas-frame-controls]'),
        acrylicFrameControls: root.querySelector('[data-acrylic-frame-controls]'),
        orderPreviewStage: root.querySelector('[data-order-preview-stage]'),
        orderPreviewFrame: root.querySelector('[data-order-preview-frame]'),
        orderPreviewCanvas: root.querySelector('[data-order-preview-canvas]'),
        orderPreviewEdgeCanvas: root.querySelector('[data-order-preview-edge-canvas]'),
        orderPreviewRollCanvas: root.querySelector('[data-order-preview-roll-canvas]'),
        orderPreviewSelection: root.querySelector('[data-order-preview-selection]'),
        orderPreviewConstruction: root.querySelector('[data-order-preview-construction]'),
        orderPreviewTitle: root.querySelector('[data-order-preview-title]'),
        orderPreviewBadge: root.querySelector('[data-order-preview-badge]'),
        orderPreviewCopy: root.querySelector('[data-order-preview-copy]'),
        orderPreviewDetail: root.querySelector('[data-order-preview-detail]'),
        secondCard: root.querySelector('[data-second-portrait-card]'),
        secondPriceWrap: root.querySelector('[data-second-price-wrap]'),
        secondPrice: root.querySelector('[data-second-price]'),
        secondCompare: root.querySelector('[data-second-compare]'),
        secondOpen: root.querySelector('[data-second-open]'),
        secondSaved: root.querySelector('[data-second-saved]'),
        secondEdit: root.querySelector('[data-second-edit]'),
        secondRemove: root.querySelector('[data-second-remove]'),
        secondDialog: root.querySelector('[data-second-dialog]'),
        secondClose: root.querySelector('[data-second-close]'),
        secondUploadView: root.querySelector('[data-second-upload-view]'),
        secondFile: root.querySelector('[data-second-file]'),
        secondFileCard: root.querySelector('[data-second-file-card]'),
        secondFilePreview: root.querySelector('[data-second-file-preview]'),
        secondFileName: root.querySelector('[data-second-file-name]'),
        secondName: root.querySelector('[data-second-name]'),
        secondCreate: root.querySelector('[data-second-create]'),
        secondProgress: root.querySelector('[data-second-progress]'),
        secondProgressTitle: root.querySelector('[data-second-progress-title]'),
        secondProgressDetail: root.querySelector('[data-second-progress-detail]'),
        secondProgressFill: root.querySelector('[data-second-progress-fill]'),
        secondResult: root.querySelector('[data-second-result]'),
        secondCanvas: root.querySelector('[data-second-canvas]'),
        secondApprove: root.querySelector('[data-second-approve]'),
        secondRetry: root.querySelector('[data-second-retry]'),
        secondError: root.querySelector('[data-second-error]'),
        previewApprove: root.querySelector('[data-preview-approve]'),
        previewRevise: root.querySelector('[data-preview-revise]'),
        previewDialog: root.querySelector('[data-preview-dialog]'),
        previewClose: root.querySelector('[data-preview-close]'),
        previewRetry: root.querySelector('[data-preview-retry]'),
        previewChangeStyle: root.querySelector('[data-preview-change-style]'),
        previewUploadNew: root.querySelector('[data-preview-upload-new]'),
        previewAdjustment: root.querySelector('[data-preview-adjustment]'),
        previewApply: root.querySelector('[data-preview-apply]'),
        previewDesigner: root.querySelectorAll('[data-preview-designer]'),
        viewPreview: root.querySelector('[data-view-preview]'),
        previewBackOptions: root.querySelector('[data-preview-back-options]'),
        progressiveDetails: root.querySelector('[data-progressive-details]'),
        flowSteps: root.querySelectorAll('[data-flow-step]'),
        wizardPanels: root.querySelectorAll('[data-wizard-panel]'),
        wizardBack: root.querySelectorAll('[data-wizard-back]'),
        styleContinue: root.querySelector('[data-style-continue]'),
        nameChoices: root.querySelectorAll('[data-name-choice]'),
        nameField: root.querySelector('[data-name-field]'),
        orderConfig: root.querySelectorAll('[data-order-config]'),
        mobileCart: root.querySelector('[data-mobile-cart]'),
        formatPriceNote: root.querySelector('[data-format-price-note]'),
        propertyFormat: root.querySelector('[data-property-format]'),
        propertySize: root.querySelector('[data-property-size]')
      };

      const mockupImageCache = new Map();
      let mockupRenderVersion = 0;

      const loadMockupImage = (key) => {
        if (mockupImageCache.has(key)) return mockupImageCache.get(key);
        const template = config.mockupTemplates?.[key];
        const pending = new Promise((resolve, reject) => {
          if (!template?.url) {
            reject(new Error(`Missing product mockup template: ${key}`));
            return;
          }
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.onload = () => resolve(image);
          image.onerror = () => reject(new Error(`Could not load product mockup template: ${key}`));
          image.src = template.url;
        });
        mockupImageCache.set(key, pending);
        return pending;
      };

      const affineForTriangles = (sourcePoints, destinationPoints) => {
        const [s0, s1, s2] = sourcePoints;
        const [d0, d1, d2] = destinationPoints;
        const denominator = s0[0] * (s1[1] - s2[1]) + s1[0] * (s2[1] - s0[1]) + s2[0] * (s0[1] - s1[1]);
        if (!denominator) return null;
        return {
          a: (d0[0] * (s1[1] - s2[1]) + d1[0] * (s2[1] - s0[1]) + d2[0] * (s0[1] - s1[1])) / denominator,
          b: (d0[1] * (s1[1] - s2[1]) + d1[1] * (s2[1] - s0[1]) + d2[1] * (s0[1] - s1[1])) / denominator,
          c: (d0[0] * (s2[0] - s1[0]) + d1[0] * (s0[0] - s2[0]) + d2[0] * (s1[0] - s0[0])) / denominator,
          d: (d0[1] * (s2[0] - s1[0]) + d1[1] * (s0[0] - s2[0]) + d2[1] * (s1[0] - s0[0])) / denominator,
          e: (d0[0] * (s1[0] * s2[1] - s2[0] * s1[1]) + d1[0] * (s2[0] * s0[1] - s0[0] * s2[1]) + d2[0] * (s0[0] * s1[1] - s1[0] * s0[1])) / denominator,
          f: (d0[1] * (s1[0] * s2[1] - s2[0] * s1[1]) + d1[1] * (s2[0] * s0[1] - s0[0] * s2[1]) + d2[1] * (s0[0] * s1[1] - s1[0] * s0[1])) / denominator
        };
      };

      const drawImageTriangle = (context, image, sourcePoints, destinationPoints) => {
        const transform = affineForTriangles(sourcePoints, destinationPoints);
        if (!transform) return;
        const clipCenter = destinationPoints.reduce((result, point) => [
          result[0] + point[0] / destinationPoints.length,
          result[1] + point[1] / destinationPoints.length
        ], [0, 0]);
        const clipPoints = destinationPoints.map((point) => {
          const deltaX = point[0] - clipCenter[0];
          const deltaY = point[1] - clipCenter[1];
          const distance = Math.hypot(deltaX, deltaY) || 1;
          const clipPadding = 1.35;
          return [
            point[0] + (deltaX / distance) * clipPadding,
            point[1] + (deltaY / distance) * clipPadding
          ];
        });
        context.save();
        context.beginPath();
        context.moveTo(clipPoints[0][0], clipPoints[0][1]);
        context.lineTo(clipPoints[1][0], clipPoints[1][1]);
        context.lineTo(clipPoints[2][0], clipPoints[2][1]);
        context.closePath();
        context.clip();
        context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.e, transform.f);
        context.drawImage(image, 0, 0);
        context.restore();
      };

      const drawArtworkRegionInMockup = (context, artwork, sourceQuad, quad) => {
        if (!artwork || !sourceQuad || sourceQuad.length !== 4 || !quad || quad.length !== 4) return;
        const width = artwork.width || artwork.naturalWidth;
        const height = artwork.height || artwork.naturalHeight;
        if (!width || !height) return;
        const [sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft] = sourceQuad;
        const [topLeft, topRight, bottomRight, bottomLeft] = quad;
        drawImageTriangle(
          context,
          artwork,
          [sourceTopLeft, sourceTopRight, sourceBottomRight],
          [topLeft, topRight, bottomRight]
        );
        drawImageTriangle(
          context,
          artwork,
          [sourceTopLeft, sourceBottomRight, sourceBottomLeft],
          [topLeft, bottomRight, bottomLeft]
        );
      };

      const drawArtworkInMockup = (context, artwork, quad) => {
        if (!artwork) return;
        const width = artwork.width || artwork.naturalWidth;
        const height = artwork.height || artwork.naturalHeight;
        if (!width || !height) return;
        drawArtworkRegionInMockup(
          context,
          artwork,
          [[0, 0], [width, 0], [width, height], [0, height]],
          quad
        );
      };

      const expandMockupQuad = (quad, amount = 1.024) => {
        const center = quad.reduce((result, point) => [result[0] + point[0] / quad.length, result[1] + point[1] / quad.length], [0, 0]);
        return quad.map((point) => [
          center[0] + (point[0] - center[0]) * amount,
          center[1] + (point[1] - center[1]) * amount
        ]);
      };

      const addMockupSurfaceFinish = (context, quad, key) => {
        if (!quad || quad.length !== 4) return;
        context.save();
        context.beginPath();
        context.moveTo(quad[0][0], quad[0][1]);
        quad.slice(1).forEach((point) => context.lineTo(point[0], point[1]));
        context.closePath();
        context.clip();
        if (key.startsWith('acrylic-')) {
          const gloss = context.createLinearGradient(quad[0][0], quad[0][1], quad[2][0], quad[2][1]);
          gloss.addColorStop(0, 'rgba(255,255,255,.22)');
          gloss.addColorStop(.2, 'rgba(255,255,255,0)');
          gloss.addColorStop(.68, 'rgba(255,255,255,.05)');
          gloss.addColorStop(1, 'rgba(255,255,255,0)');
          context.fillStyle = gloss;
          context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        } else {
          context.globalAlpha = .055;
          context.strokeStyle = '#f8f1e4';
          context.lineWidth = 1;
          for (let y = quad[0][1]; y < quad[2][1]; y += 5) {
            context.beginPath();
            context.moveTo(quad[0][0] - 4, y);
            context.lineTo(quad[1][0] + 4, y + 1);
            context.stroke();
          }
        }
        context.restore();
      };

      const addMockupInsetShade = (context, quad) => {
        if (!quad || quad.length !== 4) return;
        const innerQuad = expandMockupQuad(quad, .975);
        const edgeBands = [
          { outer: [quad[0], quad[1]], inner: [innerQuad[0], innerQuad[1]], alpha: .12 },
          { outer: [quad[0], quad[3]], inner: [innerQuad[0], innerQuad[3]], alpha: .09 },
          { outer: [quad[1], quad[2]], inner: [innerQuad[1], innerQuad[2]], alpha: .035 },
          { outer: [quad[3], quad[2]], inner: [innerQuad[3], innerQuad[2]], alpha: .05 }
        ];

        context.save();
        edgeBands.forEach(({ outer, inner, alpha }) => {
          const outerMidpoint = [
            (outer[0][0] + outer[1][0]) / 2,
            (outer[0][1] + outer[1][1]) / 2
          ];
          const innerMidpoint = [
            (inner[0][0] + inner[1][0]) / 2,
            (inner[0][1] + inner[1][1]) / 2
          ];
          const shade = context.createLinearGradient(
            outerMidpoint[0],
            outerMidpoint[1],
            innerMidpoint[0],
            innerMidpoint[1]
          );
          shade.addColorStop(0, `rgba(28,23,18,${alpha})`);
          shade.addColorStop(1, 'rgba(28,23,18,0)');
          context.beginPath();
          context.moveTo(outer[0][0], outer[0][1]);
          context.lineTo(outer[1][0], outer[1][1]);
          context.lineTo(inner[1][0], inner[1][1]);
          context.lineTo(inner[0][0], inner[0][1]);
          context.closePath();
          context.fillStyle = shade;
          context.fill();
        });
        context.restore();
      };

      const drawMockupShellOutsideQuad = (context, shell, quad) => {
        if (!shell || !quad || quad.length !== 4) return;
        context.save();
        context.beginPath();
        context.rect(0, 0, context.canvas.width, context.canvas.height);
        context.moveTo(quad[0][0], quad[0][1]);
        quad.slice(1).forEach((point) => context.lineTo(point[0], point[1]));
        context.closePath();
        context.clip('evenodd');
        context.drawImage(shell, 0, 0, context.canvas.width, context.canvas.height);
        context.restore();
      };

      const drawGalleryWrapSide = (context, artwork, quad) => {
        if (!artwork || !quad || quad.length !== 4) return;
        const width = artwork.width || artwork.naturalWidth;
        const height = artwork.height || artwork.naturalHeight;
        if (!width || !height) return;
        const stripWidth = Math.max(12, width * .085);
        drawArtworkRegionInMockup(
          context,
          artwork,
          [[width, 0], [width - stripWidth, 0], [width - stripWidth, height], [width, height]],
          quad
        );

        const seamTop = quad[0];
        const outerTop = quad[1];
        const seamBottom = quad[3];
        const outerBottom = quad[2];
        const sideShade = context.createLinearGradient(
          (seamTop[0] + seamBottom[0]) / 2,
          (seamTop[1] + seamBottom[1]) / 2,
          (outerTop[0] + outerBottom[0]) / 2,
          (outerTop[1] + outerBottom[1]) / 2
        );
        sideShade.addColorStop(0, 'rgba(36,27,19,.08)');
        sideShade.addColorStop(1, 'rgba(36,27,19,.3)');
        context.save();
        context.beginPath();
        context.moveTo(quad[0][0], quad[0][1]);
        quad.slice(1).forEach((point) => context.lineTo(point[0], point[1]));
        context.closePath();
        context.fillStyle = sideShade;
        context.fill();
        context.clip();
        context.globalAlpha = .1;
        context.strokeStyle = '#f7efe3';
        context.lineWidth = 1;
        for (let y = quad[0][1]; y < quad[3][1]; y += 5) {
          context.beginPath();
          context.moveTo(quad[0][0], y);
          context.lineTo(quad[1][0], y + 1);
          context.stroke();
        }
        context.restore();
      };

      const renderOrderProductMockup = async () => {
        if (!els.orderPreviewCanvas || !els.previewCanvas) return;
        const key = els.orderPreviewStage?.dataset.format || 'rolled';
        const template = config.mockupTemplates?.[key];
        if (!template) return;
        const renderVersion = ++mockupRenderVersion;
        try {
          const shell = await loadMockupImage(key);
          if (renderVersion !== mockupRenderVersion) return;
          const canvas = els.orderPreviewCanvas;
          if (canvas.width !== shell.naturalWidth) canvas.width = shell.naturalWidth;
          if (canvas.height !== shell.naturalHeight) canvas.height = shell.naturalHeight;
          const context = canvas.getContext('2d');
          context.setTransform(1, 0, 0, 1, 0, 0);
          context.clearRect(0, 0, canvas.width, canvas.height);
          const artworkBleed = template.artworkBleed || 1.03;
          const artworkQuad = expandMockupQuad(template.quad, artworkBleed);
          if (template.composition === 'inset' || template.composition === 'gallery-wrap') {
            context.drawImage(shell, 0, 0, canvas.width, canvas.height);
          }
          drawArtworkInMockup(context, els.previewCanvas, artworkQuad);
          addMockupSurfaceFinish(context, artworkQuad, key);
          if (template.composition === 'inset') {
            drawMockupShellOutsideQuad(context, shell, template.quad);
            addMockupInsetShade(context, template.quad);
          } else if (template.composition === 'gallery-wrap') {
            drawGalleryWrapSide(context, els.previewCanvas, template.sideQuad);
          } else {
            context.drawImage(shell, 0, 0, canvas.width, canvas.height);
          }
        } catch (error) {
          console.warn(error);
          const canvas = els.orderPreviewCanvas;
          const context = canvas.getContext('2d');
          context.setTransform(1, 0, 0, 1, 0, 0);
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.fillStyle = '#f4efe7';
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(els.previewCanvas, canvas.width * .3, canvas.height * .1, canvas.width * .4, canvas.height * .6);
        }
      };

      if (els.uploadLater) els.uploadLater.checked = false;

      const findVariant = () => config.variants.find((variant) => (
        canonicalFormat(variantFormat(variant, config.optionNames)) === state.style &&
        normalize(variantSize(variant)) === normalize(state.size)
      ));

      const findSecondVariant = () => (config.secondPortraitVariants || []).find((variant) => (
        canonicalFormat(variantFormat(variant, config.secondPortraitOptionNames)) === state.style &&
        normalize(optionValue(variant, 'Size', config.secondPortraitOptionNames)) === normalize(state.size)
      ));

      const variantAvailableFor = (style, size) => config.variants.some((variant) => (
        canonicalFormat(variantFormat(variant, config.optionNames)) === canonicalFormat(style) &&
        normalize(variantSize(variant)) === normalize(size)
      ));

      const setPressed = (buttons, activeValue, attr) => {
        buttons.forEach((button) => {
          const active = button.getAttribute(attr) === activeValue;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const updateFlowStep = (currentStep) => {
        els.flowSteps.forEach((step) => {
          const value = Number(step.dataset.flowStep || 0);
          step.classList.toggle('is-current', value === currentStep);
          step.classList.toggle('is-complete', value < currentStep);
        });
      };

      const showWizardStep = (step, { scroll = false } = {}) => {
        const nextStep = Math.min(5, Math.max(1, Number(step) || 1));
        state.wizardStep = nextStep;
        updateFlowStep(nextStep);
        els.wizardPanels.forEach((panel) => {
          const panelStep = Number(panel.dataset.wizardPanel);
          panel.hidden = panelStep !== nextStep && !(nextStep === 4 && panelStep === 3);
          if (panel.classList.contains('amp-wizard-dialog')) {
            if (panelStep === nextStep && (nextStep === 2 || nextStep === 3)) {
              panel.setAttribute('aria-modal', 'true');
            } else {
              panel.removeAttribute('aria-modal');
            }
          }
        });
        root.classList.remove('amp-style-picker-open');
        document.body.classList.remove('amp-style-picker-is-open');
        document.body.classList.toggle('amp-wizard-dialog-is-open', nextStep === 2 || nextStep === 3);
        if (els.artStyleBackdrop) els.artStyleBackdrop.hidden = true;
        els.artStyleGroup?.removeAttribute('aria-modal');

        const showMobileCart = nextStep === 5 && (state.previewApproved || state.designerService);
        if (els.mobileCart) els.mobileCart.hidden = !showMobileCart;
        document.body.classList.toggle('amp-has-mobile-cart', showMobileCart);

        if (nextStep === 2 || nextStep === 3) {
          window.setTimeout(() => {
            const activePanel = root.querySelector(`[data-wizard-panel="${nextStep}"]`);
            const focusTarget = activePanel?.querySelector(nextStep === 2
              ? '[data-art-style-option].is-active'
              : '[data-name-choice].is-active');
            focusTarget?.focus({ preventScroll: true });
          }, 100);
        } else if (scroll) {
          const mobileStepTarget = window.matchMedia('(max-width: 749px)').matches
            ? root.querySelector('.amp-flow-steps')
            : null;
          const target = mobileStepTarget || (nextStep === 5
            ? els.orderPreview
            : root.querySelector(`[data-wizard-panel="${nextStep}"]`));
          window.setTimeout(() => target?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
        }
      };

      const closeStylePicker = ({ advance = false } = {}) => {
        root.classList.remove('amp-style-picker-open');
        document.body.classList.remove('amp-style-picker-is-open');
        if (els.artStyleBackdrop) els.artStyleBackdrop.hidden = true;
        els.artStyleGroup?.removeAttribute('aria-modal');
        showWizardStep(advance ? 3 : 1, { scroll: !advance });
      };

      const openStylePicker = () => {
        if (!state.sourceFiles.filter(Boolean).length) return;
        showWizardStep(2, { scroll: true });
      };

      const setPhotoState = (hasPhoto, { reveal = false } = {}) => {
        root.classList.toggle('amp-has-photo', hasPhoto);
        if (els.progressiveDetails) els.progressiveDetails.hidden = !hasPhoto;
        if (els.uploadStart) els.uploadStart.hidden = hasPhoto;
        if (!hasPhoto && els.photoContinue) els.photoContinue.hidden = true;
        if (hasPhoto) requestAnimationFrame(updateArtStyleArrows);
        if (!hasPhoto) showWizardStep(1);
        if (hasPhoto && reveal) {
          requestAnimationFrame(() => requestAnimationFrame(() => showWizardStep(2)));
        }
      };

      const updatePhotoProperties = () => {
        els.photoProperties.innerHTML = '';
        state.uploadedUrls.slice(0, 4).forEach((url, index) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[_pet_photo_${index + 1}]`;
          input.value = url;
          els.photoProperties.append(input);
        });
        els.propertyUpload.value = state.uploadLater ? 'pending' : '';
      };

      const showError = (message) => {
        if (!els.formErrorWrap || !els.formError) return;
        els.formError.textContent = message || '';
        els.formErrorWrap.hidden = !message;
      };

      const syncOrderFormatPreview = () => {
        const format = canonicalFormat(state.style);
        const formatKeys = {
          'Rolled Canvas': 'rolled',
          'Gallery-Wrapped Canvas': 'wrapped',
          'Black Framed Canvas': 'framed-black',
          'Natural Wood Framed Canvas': 'framed-natural',
          'Gold Framed Canvas': 'framed-gold',
          'Black Framed Acrylic': 'acrylic-black',
          'Gold Framed Acrylic': 'acrylic-gold'
        };
        const formatKey = formatKeys[format] || 'rolled';
        if (els.orderPreviewStage) els.orderPreviewStage.dataset.format = formatKey;
        if (els.orderPreviewSelection) {
          els.orderPreviewSelection.textContent = `${displayFormat(format)} · ${state.size}`;
        }
        if (els.orderPreviewConstruction) {
          const constructionNotes = {
            'Rolled Canvas': 'Loose canvas · ships rolled in a protective tube',
            'Gallery-Wrapped Canvas': '1.5 in deep inner wood stretcher · ready to hang',
            'Black Framed Canvas': 'Stretched canvas · visible black outer frame',
            'Natural Wood Framed Canvas': 'Stretched canvas · visible natural wood outer frame',
            'Gold Framed Canvas': 'Stretched canvas · visible gold outer frame',
            'Black Framed Acrylic': 'Glossy acrylic panel · visible black outer frame',
            'Gold Framed Acrylic': 'Glossy acrylic panel · visible gold outer frame'
          };
          els.orderPreviewConstruction.textContent = constructionNotes[format] || '';
        }
        if (els.orderPreviewCanvas) {
          els.orderPreviewCanvas.setAttribute('aria-label', `Your selected portrait shown as ${displayFormat(format)}`);
        }
        setPressed(els.orderMaterialButtons, state.material, 'data-order-material');
        setPressed(els.orderCanvasFinishButtons, state.canvasFinish, 'data-order-canvas-finish');
        setPressed(els.orderCanvasColorButtons, state.canvasColor, 'data-order-canvas-color');
        setPressed(els.orderAcrylicColorButtons, state.acrylicColor, 'data-order-acrylic-color');
        if (els.canvasFinishControls) els.canvasFinishControls.hidden = state.material !== 'Canvas';
        if (els.canvasFrameControls) els.canvasFrameControls.hidden = state.material !== 'Canvas' || state.canvasFinish !== 'Framed';
        if (els.acrylicFrameControls) els.acrylicFrameControls.hidden = state.material !== 'Acrylic';

        const buttons = [
          ...els.orderMaterialButtons,
          ...els.orderCanvasFinishButtons,
          ...els.orderCanvasColorButtons,
          ...els.orderAcrylicColorButtons
        ];
        buttons.forEach((button) => { button.disabled = false; });
        renderOrderProductMockup();
      };

      const refresh = () => {
        const variant = findVariant() || config.variants[0];
        if (!variant) return;
        const currentStyle = variantFormat(variant, config.optionNames) || state.style;
        const currentSize = variantSize(variant) || state.size;
        const extraPetTotal = Math.max(0, state.pets - 1) * 1500;
        const rushTotal = state.rush ? 1500 : 0;
        const secondVariant = findSecondVariant();
        const secondTotal = state.secondPortrait?.approved && secondVariant ? Number(secondVariant.price || 0) : 0;
        const total = Number(variant.price || 0) + extraPetTotal + rushTotal + secondTotal;

        els.variantInput.value = variant.id;
        els.propertyArtStyle.value = state.artStyle;
        if (els.propertyFormat) els.propertyFormat.value = currentStyle;
        if (els.propertySize) els.propertySize.value = currentSize;
        els.propertyPets.value = String(state.pets);
        els.price.textContent = money(variant.price, config.currency);
        if (Number(variant.compare_at_price || 0) > Number(variant.price || 0)) {
          els.compare.hidden = false;
          els.compare.textContent = money(variant.compare_at_price, config.currency);
        } else {
          els.compare.hidden = true;
        }
        els.summaryArtStyle.textContent = state.artStyle || 'Not selected';
        els.summaryFormat.textContent = displayFormat(currentStyle);
        els.summaryPets.textContent = String(state.pets);
        els.summaryExtraRow.hidden = state.pets <= 1;
        els.summaryExtraPets.textContent = `${state.pets - 1} x ${money(1500, config.currency)}`;
        els.summaryRushRow.hidden = !state.rush;
        if (els.summarySecondRow) els.summarySecondRow.hidden = !state.secondPortrait?.approved;
        if (els.summarySecondPrice) els.summarySecondPrice.textContent = secondVariant ? money(secondVariant.price, config.currency) : '';
        els.summaryTotal.textContent = money(total, config.currency);
        if (els.mobileTotal) els.mobileTotal.textContent = money(total, config.currency);
        els.summarySizeRow.hidden = false;
        els.summarySize.textContent = currentSize;
        els.deliveryCopy.textContent = 'Your approved artwork is saved with the order. A high-resolution digital copy is included with every physical format.';
        if (els.secondCard) els.secondCard.classList.toggle('is-added', Boolean(state.secondPortrait?.approved));
        if (els.secondPriceWrap) els.secondPriceWrap.hidden = !secondVariant;
        if (els.secondCompare) els.secondCompare.textContent = secondVariant ? money(secondVariant.compare_at_price, config.currency) : '';
        if (els.secondPrice) els.secondPrice.textContent = secondVariant ? money(secondVariant.price, config.currency) : 'Unavailable';
        if (els.secondOpen) {
          els.secondOpen.hidden = Boolean(state.secondPortrait?.approved);
          els.secondOpen.disabled = !secondVariant;
          els.secondOpen.textContent = secondVariant ? `Add a 2nd for ${money(secondVariant.price, config.currency)} — save 40%` : 'Second portrait unavailable';
        }
        if (els.secondSaved) els.secondSaved.hidden = !state.secondPortrait?.approved;
        if (els.formatPriceNote) {
          const notes = {
            'Rolled Canvas': 'Printed canvas only. Ships safely rolled, with no inner or outer frame.',
            'Gallery-Wrapped Canvas': 'Canvas mounted on a hidden inner wood stretcher. Ready to hang with no visible outer frame.',
            'Black Framed Canvas': 'Stretched canvas finished with a visible black decorative outer frame.',
            'Natural Wood Framed Canvas': 'Stretched canvas finished with a visible natural wood decorative outer frame.',
            'Gold Framed Canvas': 'Stretched canvas finished with a visible gold decorative outer frame.',
            'Black Framed Acrylic': 'Premium glossy acrylic wall art finished with a visible black frame.',
            'Gold Framed Acrylic': 'Premium glossy acrylic wall art finished with a visible gold frame.'
          };
          els.formatPriceNote.textContent = notes[currentStyle] || 'Choose the product format for your approved portrait.';
        }

        setPressed(els.artStyleButtons, state.artStyle, 'data-art-style-option');
        setPressed(els.styleButtons, state.style, 'data-style-option');
        setPressed(els.sizeButtons, state.size, 'data-size-option');
        setPressed(els.petButtons, String(state.pets), 'data-pet-count');

        els.sizeButtons.forEach((button) => {
          const available = variantAvailableFor(state.style, button.dataset.sizeOption);
          button.classList.toggle('is-unavailable', !available);
          button.disabled = !available;
          const priceOutput = button.querySelector('[data-size-choice-price]');
          const sizeVariant = config.variants.find((candidate) => (
            canonicalFormat(variantFormat(candidate, config.optionNames)) === state.style &&
            normalize(variantSize(candidate)) === normalize(button.dataset.sizeOption)
          ));
          if (priceOutput && sizeVariant) priceOutput.textContent = money(sizeVariant.price, config.currency);
        });
        els.styleButtons.forEach((button) => {
          const available = variantAvailableFor(button.dataset.styleOption, state.size);
          button.classList.toggle('is-unavailable', !available);
          button.disabled = !available;
        });
        syncOrderFormatPreview();

        updatePhotoProperties();
      };

      const uploadFile = async (file, purpose = 'order-photo', onProgress = null) => {
        if (!config.uploadEndpoint) {
          throw new Error(text('uploadNotConfigured', 'Photo upload is not configured yet. Choose Upload later to place the order now.'));
        }
        onProgress?.({ phase: 'preparing', percent: 0 });
        const signResponse = await fetch(config.uploadEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ filename: file.name, contentType: file.type, size: file.size, purpose })
        });
        if (!signResponse.ok) throw new Error(text('prepareFailed', 'Could not prepare upload. Please try again.'));
        const signed = await signResponse.json();
        const uploadUrl = signed.uploadUrl || signed.url;
        const fileUrl = signed.fileUrl || signed.publicUrl;
        if (!uploadUrl || !fileUrl) throw new Error(text('responseMissing', 'Upload response is missing a file URL.'));
        onProgress?.({ phase: 'uploading', percent: 0 });
        if (typeof onProgress === 'function' && typeof XMLHttpRequest !== 'undefined') {
          await new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('PUT', uploadUrl, true);
            request.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
            request.upload.addEventListener('progress', (event) => {
              if (!event.lengthComputable || !event.total) return;
              onProgress({
                phase: 'uploading',
                percent: Math.min(100, Math.round((event.loaded / event.total) * 100))
              });
            });
            request.addEventListener('load', () => {
              if (request.status >= 200 && request.status < 300) {
                onProgress({ phase: 'complete', percent: 100 });
                resolve();
              } else {
                reject(new Error(text('uploadFailed', 'Upload failed. Please try again.')));
              }
            });
            request.addEventListener('error', () => reject(new Error(text('uploadFailed', 'Upload failed. Please try again.'))));
            request.addEventListener('abort', () => reject(new Error(text('uploadFailed', 'Upload failed. Please try again.'))));
            request.send(file);
          });
        } else {
          const putResponse = await fetch(uploadUrl, { method: 'PUT', body: file, headers: { 'Content-Type': file.type || 'application/octet-stream' } });
          if (!putResponse.ok) throw new Error(text('uploadFailed', 'Upload failed. Please try again.'));
          onProgress?.({ phase: 'complete', percent: 100 });
        }
        return fileUrl;
      };

      const inspectResolution = (file, previewUrl) => new Promise((resolve) => {
        if (!previewUrl || !file.type || !file.type.startsWith('image/') || file.type.toLowerCase().includes('heic')) {
          resolve('');
          return;
        }
        const image = new Image();
        image.onload = () => {
          const shortEdge = Math.min(image.naturalWidth || 0, image.naturalHeight || 0);
          resolve(shortEdge > 0 && shortEdge < 1000 ? text('lowResolution', 'Short edge is under 1000px. You can continue, but a larger photo may create a better proof.') : '');
        };
        image.onerror = () => resolve('');
        image.src = previewUrl;
      });

      const resetPreview = (message = '') => {
        const returnStep = state.sourceFiles.filter(Boolean).length
          ? Math.min(3, Math.max(1, state.wizardStep || 1))
          : 1;
        state.preview = null;
        state.previewApproved = false;
        state.designerService = false;
        root.classList.remove('amp-preview-approved');
        root.classList.remove('amp-preview-ready', 'amp-generating');
        document.body.classList.remove('amp-preview-is-loading', 'amp-preview-is-reviewing');
        els.orderConfig?.forEach((element) => { element.hidden = true; });
        if (els.previewResult) els.previewResult.hidden = true;
        if (els.previewLoading) els.previewLoading.hidden = true;
        if (els.previewBackOptions) els.previewBackOptions.hidden = true;
        if (els.previewApprove) {
          els.previewApprove.classList.remove('is-approved');
          els.previewApprove.textContent = 'Yes — I love it';
        }
        if (els.previewMessage) els.previewMessage.textContent = message;
        showWizardStep(returnStep);
      };

      const decodePreviewImage = async (file) => {
        if ('createImageBitmap' in window) {
          try {
            const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
            return { source: bitmap, width: bitmap.width, height: bitmap.height, close: () => bitmap.close() };
          } catch (_error) {}
        }
        return new Promise((resolve, reject) => {
          const url = URL.createObjectURL(file);
          const image = new Image();
          image.onload = () => resolve({
            source: image,
            width: image.naturalWidth,
            height: image.naturalHeight,
            close: () => URL.revokeObjectURL(url)
          });
          image.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error('This photo format could not be read. On iPhone, choose the still photo rather than the video portion of a Live Photo.'));
          };
          image.src = url;
        });
      };

      const preparePreviewFile = async (file) => {
        const decoded = await decodePreviewImage(file);
        try {
          const longest = Math.max(decoded.width, decoded.height);
          // The preview model returns a 1K proof. A 1600px identity reference
          // keeps coat/eye detail while cutting mobile upload and model latency.
          // The untouched original is uploaded separately for the paid order.
          const scale = Math.min(1, 1600 / Math.max(1, longest));
          const width = Math.max(1, Math.round(decoded.width * scale));
          const height = Math.max(1, Math.round(decoded.height * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d', { alpha: false });
          context.fillStyle = '#fff';
          context.fillRect(0, 0, width, height);
          context.drawImage(decoded.source, 0, 0, width, height);
          const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', .84));
          if (!blob) throw new Error('Could not optimize this photo. Please try a JPG or PNG file.');
          return new File([blob], 'portrait-preview.jpg', { type: 'image/jpeg', lastModified: Date.now() });
        } finally {
          decoded.close();
        }
      };

      const previewErrorMessage = (code) => ({
        daily_preview_limit_reached: 'Today’s free preview capacity has been reached. Please return tomorrow or try a different photo later.',
        client_preview_limit_reached: 'You have created 6 free previews today. Please return tomorrow for more.',
        source_preview_limit_reached: 'This photo has already created 3 free previews. Upload a different photo or try again tomorrow.',
        preview_timeout: 'This detailed preview took longer than expected. Please retry without leaving this page.',
        preview_service_busy: 'The preview studio is busy right now. Please try again in a few minutes.',
        preview_photo_not_accepted: 'This photo could not be processed. Please try a clearer pet photo.',
        preview_service_billing_required: 'Instant previews are temporarily unavailable. Please try again later.',
        preview_service_auth_failed: 'The preview studio is temporarily unavailable. Please try again later.',
        preview_service_access_denied: 'The preview studio was temporarily unavailable. Please try again now.',
        preview_style_unavailable: 'The selected portrait model is temporarily unavailable. Please try again later.',
        preview_service_unavailable: 'The preview studio is temporarily unavailable. Please try again in a few minutes.',
        preview_service_unreachable: 'The preview studio could not be reached. Please check your connection and try again.',
        preview_request_invalid: 'The preview studio rejected its current settings. Please try again shortly.',
        preview_no_image: 'The preview studio did not return an image. Please try again.',
        preview_invalid_output: 'The preview studio returned an unusable image. Please try again.',
        preview_failed: 'The preview could not be completed. Please try again in a moment.',
        unsafe_adjustment: 'Please request only a small visual change such as background color, framing, or brush energy.'
      }[code] || 'We could not create this preview. Please try again with a clear pet photo.');

      const samplePreviewLuminance = (context, x, y, width, height) => {
        const pixels = context.getImageData(x, y, width, height).data;
        let total = 0;
        let samples = 0;
        for (let index = 0; index < pixels.length; index += 64) {
          total += (pixels[index] * .2126 + pixels[index + 1] * .7152 + pixels[index + 2] * .0722) / 255;
          samples += 1;
        }
        return samples ? total / samples : .5;
      };

      const paintPortraitName = (context, canvas, name, artStyle) => {
        const normalizedStyle = String(artStyle || '').toLowerCase();
        const settings = {
          watercolor: {
            font: (size) => `italic 600 ${size}px Georgia, "Noto Serif SC", serif`,
            darkInk: '#62483b', lightInk: '#f3e8d3', roughness: 1.1, strokeWidth: 1.15
          },
          'palette-knife': {
            font: (size) => `700 ${size}px Georgia, "Noto Serif SC", serif`,
            darkInk: '#49382f', lightInk: '#f0dfc3', roughness: 1.8, strokeWidth: 1.55
          },
          abstract: {
            font: (size) => `800 ${size}px "Trebuchet MS", "Noto Sans SC", sans-serif`,
            darkInk: '#26453e', lightInk: '#f7e6c5', roughness: 1.35, strokeWidth: 1.25
          },
          charcoal: {
            font: (size) => `600 ${size}px "Segoe Print", "Bradley Hand", "Noto Serif SC", cursive`,
            darkInk: '#393531', lightInk: '#eee7da', roughness: 1.5, strokeWidth: .9
          }
        }[normalizedStyle] || {
          font: (size) => `600 ${size}px Georgia, "Noto Serif SC", serif`,
          darkInk: '#463d35', lightInk: '#f2e8d8', roughness: 1, strokeWidth: 1
        };

        context.save();
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.lineJoin = 'round';
        context.lineCap = 'round';

        let fontSize = Math.round(canvas.width * (normalizedStyle === 'abstract' ? .061 : .058));
        fontSize = Math.max(34, Math.min(62, fontSize));
        do {
          context.font = settings.font(fontSize);
          if (context.measureText(name).width <= canvas.width * .72 || fontSize <= 32) break;
          fontSize -= 2;
        } while (fontSize > 32);

        const x = canvas.width / 2;
        const y = canvas.height - Math.max(58, Math.round(canvas.height * .054));
        const surfaceLuminance = samplePreviewLuminance(
          context,
          Math.round(canvas.width * .12),
          Math.round(canvas.height * .84),
          Math.round(canvas.width * .76),
          Math.round(canvas.height * .12)
        );
        const useLightInk = surfaceLuminance < .46;
        const ink = useLightInk ? settings.lightInk : settings.darkInk;
        const edge = useLightInk ? 'rgba(35,31,27,.28)' : 'rgba(250,244,231,.24)';
        const passes = normalizedStyle === 'charcoal'
          ? [[-1.4, .6, .16], [1.2, -.8, .12], [.3, 1.2, .1]]
          : normalizedStyle === 'palette-knife'
            ? [[-1.7, 1.2, .18], [1.5, -.9, .14]]
            : [[-settings.roughness, .5, .12], [settings.roughness, -.45, .09]];

        context.fillStyle = ink;
        passes.forEach(([offsetX, offsetY, alpha]) => {
          context.globalAlpha = alpha;
          context.fillText(name, x + offsetX, y + offsetY);
        });
        context.globalAlpha = .94;
        context.lineWidth = settings.strokeWidth;
        context.strokeStyle = edge;
        context.strokeText(name, x, y);
        context.fillText(name, x, y);

        if (normalizedStyle === 'watercolor') {
          context.globalAlpha = .34;
          context.lineWidth = 1;
          context.beginPath();
          const textWidth = Math.min(context.measureText(name).width, canvas.width * .68);
          context.moveTo(x - textWidth * .39, y + fontSize * .48);
          context.quadraticCurveTo(x, y + fontSize * .58, x + textWidth * .39, y + fontSize * .45);
          context.strokeStyle = ink;
          context.stroke();
        }
        context.restore();
      };

      const syncOrderPreview = () => {
        renderOrderProductMockup();
        if (state.designerService) {
          if (els.orderPreviewTitle) els.orderPreviewTitle.textContent = 'Your current preview';
          if (els.orderPreviewBadge) els.orderPreviewBadge.textContent = 'Designer selected';
          if (els.orderPreviewCopy) els.orderPreviewCopy.textContent = 'Your designer will refine this after checkout';
          if (els.orderPreviewDetail) els.orderPreviewDetail.textContent = 'A new proof will be emailed within 24 hours. Nothing prints until you approve it.';
        } else {
          if (els.orderPreviewTitle) els.orderPreviewTitle.textContent = 'Your approved portrait';
          if (els.orderPreviewBadge) els.orderPreviewBadge.textContent = '✓ Approved';
          if (els.orderPreviewCopy) els.orderPreviewCopy.textContent = 'This exact artwork goes to print';
          if (els.orderPreviewDetail) els.orderPreviewDetail.textContent = 'Now choose the format and size for this portrait.';
        }
      };

      const drawPreview = (sourceUrl, petName) => new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => {
          const canvas = els.previewCanvas;
          const context = canvas.getContext('2d');
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(image, 0, 0, canvas.width, canvas.height);

          const cleanName = String(petName || '').trim().slice(0, 40);
          if (cleanName) {
            paintPortraitName(context, canvas, cleanName, state.artStyle);
          }
          syncOrderPreview();
          resolve();
        };
        image.onerror = () => reject(new Error('The finished preview could not be displayed. Please try again.'));
        image.src = sourceUrl;
      });

      const saveCurrentPreview = async () => {
        if (!state.preview) throw new Error('save_failed');
        if (state.preview.referenceUrl) return state.preview.referenceUrl;
        const blob = await new Promise((resolve) => els.previewCanvas?.toBlob(resolve, 'image/jpeg', .94));
        if (!blob) throw new Error('save_failed');
        const file = new File([blob], 'approved-portrait-preview.jpg', {
          type: 'image/jpeg',
          lastModified: Date.now()
        });
        state.preview.referenceUrl = await uploadFile(file, 'order-photo');
        return state.preview.referenceUrl;
      };

      let previewProgressTimer = null;
      let previewStartedAt = 0;
      const startPreviewProgress = () => {
        clearInterval(previewProgressTimer);
        previewStartedAt = Date.now();
        root.classList.add('amp-generating');
        document.body.classList.add('amp-preview-is-loading');
        showWizardStep(4);
        if (els.previewLoading) els.previewLoading.hidden = false;
        if (els.previewResult) els.previewResult.hidden = true;
        if (els.previewProgress) els.previewProgress.style.width = '6%';
        previewProgressTimer = setInterval(() => {
          const seconds = Math.floor((Date.now() - previewStartedAt) / 1000);
          const progress = Math.min(92, 8 + Math.round(84 * (1 - Math.exp(-seconds / 28))));
          if (els.previewProgress) els.previewProgress.style.width = `${progress}%`;
          if (els.previewElapsed) els.previewElapsed.textContent = `Estimated progress · ${progress}% · ${seconds}s elapsed`;
          if (seconds < 7) {
            els.previewStage.textContent = 'Preparing the paper…';
            els.previewStageDetail.textContent = 'Setting up your portrait canvas';
          } else if (seconds < 20) {
            els.previewStage.textContent = 'Studying your pet…';
            els.previewStageDetail.textContent = 'Reading the eyes, expression, coat, and markings';
          } else if (seconds < 42) {
            els.previewStage.textContent = 'Painting the first layers…';
            els.previewStageDetail.textContent = 'Applying your selected art direction';
          } else {
            els.previewStage.textContent = 'Refining the likeness…';
            els.previewStageDetail.textContent = 'Checking the eyes, markings, and distinctive features';
          }
        }, 1000);
      };

      const stopPreviewProgress = () => {
        clearInterval(previewProgressTimer);
        previewProgressTimer = null;
        root.classList.remove('amp-generating');
        document.body.classList.remove('amp-preview-is-loading');
        if (els.previewProgress) els.previewProgress.style.width = '100%';
      };

      const waitForPreviewResult = async (requestBody) => {
        const startedAt = Date.now();
        const overallTimeout = 195000;
        while (Date.now() - startedAt < overallTimeout) {
          const controller = new AbortController();
          const remaining = Math.max(1, overallTimeout - (Date.now() - startedAt));
          const requestTimeout = setTimeout(() => controller.abort(), Math.min(10000, remaining));
          try {
            const response = await fetch(config.previewEndpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              signal: controller.signal,
              body: JSON.stringify(requestBody)
            });
            const body = await response.json().catch(() => ({}));
            if (response.status === 202 && body?.status === 'processing') {
              await new Promise((resolve) => setTimeout(resolve, 2000));
              continue;
            }
            if (!response.ok || !body?.result?.sourceUrl) throw new Error(body.error || 'preview_failed');
            return body.result;
          } catch (error) {
            if (error?.name !== 'AbortError' && error?.name !== 'TypeError') throw error;
            if (Date.now() - startedAt >= overallTimeout) throw new Error('preview_timeout');
            await new Promise((resolve) => setTimeout(resolve, 2000));
          } finally {
            clearTimeout(requestTimeout);
          }
        }
        throw new Error('preview_timeout');
      };

      let secondPreviewProgressTimer = null;
      let secondSourceObjectUrl = '';
      const setSecondError = (message = '') => {
        if (!els.secondError) return;
        els.secondError.textContent = message;
        els.secondError.hidden = !message;
      };
      const setSecondProgress = (title, detail, percent) => {
        if (els.secondProgressTitle) els.secondProgressTitle.textContent = title;
        if (els.secondProgressDetail) els.secondProgressDetail.textContent = detail;
        if (els.secondProgressFill) els.secondProgressFill.style.width = `${Math.max(0, Math.min(100, percent))}%`;
      };
      const showSecondView = (view) => {
        if (els.secondUploadView) els.secondUploadView.hidden = view !== 'upload';
        if (els.secondProgress) els.secondProgress.hidden = view !== 'progress';
        if (els.secondResult) els.secondResult.hidden = view !== 'result';
      };
      const resetSecondComposer = ({ clearFile = true } = {}) => {
        clearInterval(secondPreviewProgressTimer);
        secondPreviewProgressTimer = null;
        setSecondError('');
        showSecondView('upload');
        if (clearFile) {
          if (secondSourceObjectUrl) URL.revokeObjectURL(secondSourceObjectUrl);
          secondSourceObjectUrl = '';
          if (els.secondFile) els.secondFile.value = '';
          if (els.secondFileCard) els.secondFileCard.hidden = true;
          if (els.secondFilePreview) els.secondFilePreview.removeAttribute('src');
          if (els.secondFileName) els.secondFileName.textContent = '';
          if (els.secondCreate) els.secondCreate.disabled = true;
        }
      };
      const openSecondDialog = ({ reset = false } = {}) => {
        if (!els.secondDialog || !findSecondVariant()) return;
        if (reset) resetSecondComposer();
        els.secondDialog.showModal();
      };
      const drawSecondPreview = (sourceUrl, petName) => new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => {
          if (!els.secondCanvas) return reject(new Error('preview_failed'));
          const context = els.secondCanvas.getContext('2d');
          context.clearRect(0, 0, els.secondCanvas.width, els.secondCanvas.height);
          context.drawImage(image, 0, 0, els.secondCanvas.width, els.secondCanvas.height);
          const cleanName = String(petName || '').trim().slice(0, 40);
          if (cleanName) paintPortraitName(context, els.secondCanvas, cleanName, state.artStyle);
          resolve();
        };
        image.onerror = () => reject(new Error('preview_invalid_output'));
        image.src = sourceUrl;
      });
      const createSecondPortraitPreview = async () => {
        const file = els.secondFile?.files?.[0];
        if (!file) {
          setSecondError('Upload a clear pet photo first.');
          return;
        }
        if (file.size > Number(config.maxFileBytes || 26214400)) {
          setSecondError('This photo is larger than 25 MB. Choose a smaller file.');
          return;
        }
        setSecondError('');
        if (els.secondCreate) els.secondCreate.disabled = true;
        showSecondView('progress');
        setSecondProgress('Uploading the photo…', '0%', 0);
        try {
          const originalUrl = await uploadFile(file, 'order-photo', ({ percent = 0 }) => {
            const scaled = Math.round(percent * .32);
            setSecondProgress('Uploading the photo…', `${Math.round(percent)}% uploaded`, scaled);
          });
          setSecondProgress('Preparing the portrait…', 'Optimizing the image', 36);
          const previewFile = await preparePreviewFile(file);
          const sourceUrl = await uploadFile(previewFile, 'portrait-preview');
          let simulated = 42;
          secondPreviewProgressTimer = setInterval(() => {
            simulated = Math.min(92, simulated + Math.max(1, Math.round((92 - simulated) * .08)));
            setSecondProgress('Painting the second portrait…', `${simulated}%`, simulated);
          }, 1200);
          const random = crypto.getRandomValues(new Uint32Array(4));
          const requestId = `web_second_${Date.now()}_${Array.from(random).map((value) => value.toString(16)).join('')}`;
          const requestBody = {
            requestId,
            sourceUrl,
            style: state.artStyle,
            petCount: 1,
            petName: els.secondName?.value || '',
            accessoryPolicy: els.previewAccessories?.value || 'keep_collar_no_tag',
            featurePolicy: els.previewFeatures?.checked === false ? 'soften' : 'preserve',
            modification: ''
          };
          const result = await waitForPreviewResult(requestBody);
          clearInterval(secondPreviewProgressTimer);
          secondPreviewProgressTimer = null;
          setSecondProgress('Finishing the portrait…', '100%', 100);
          await drawSecondPreview(result.sourceUrl, els.secondName?.value || '');
          state.secondPortrait = {
            approved: false,
            originalUrl,
            name: String(els.secondName?.value || '').trim().slice(0, 40),
            preview: result,
            referenceUrl: ''
          };
          showSecondView('result');
        } catch (error) {
          clearInterval(secondPreviewProgressTimer);
          secondPreviewProgressTimer = null;
          showSecondView('upload');
          setSecondError(previewErrorMessage(error?.message));
        } finally {
          if (els.secondCreate) els.secondCreate.disabled = !els.secondFile?.files?.length;
        }
      };
      const approveSecondPortrait = async () => {
        if (!state.secondPortrait?.preview || !els.secondCanvas) return;
        if (els.secondApprove) els.secondApprove.disabled = true;
        setSecondError('');
        showSecondView('progress');
        setSecondProgress('Saving the second portrait…', 'Preparing the print file', 20);
        try {
          const blob = await new Promise((resolve) => els.secondCanvas.toBlob(resolve, 'image/jpeg', .94));
          if (!blob) throw new Error('preview_invalid_output');
          const file = new File([blob], 'approved-second-portrait.jpg', { type: 'image/jpeg', lastModified: Date.now() });
          state.secondPortrait.referenceUrl = await uploadFile(file, 'order-photo', ({ percent = 0 }) => {
            setSecondProgress('Saving the second portrait…', `${Math.round(percent)}%`, Math.max(20, percent));
          });
          state.secondPortrait.approved = true;
          setSecondProgress('Second portrait saved', '100%', 100);
          els.secondDialog?.close();
          refresh();
          els.secondCard?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (error) {
          showSecondView('result');
          setSecondError(previewErrorMessage(error?.message));
        } finally {
          if (els.secondApprove) els.secondApprove.disabled = false;
        }
      };

      const createPortraitPreview = async (adjustment = '') => {
        if (!els.previewCreate || !config.previewEndpoint) {
          resetPreview('Instant preview is temporarily unavailable. Please try again later.');
          return;
        }
        const styleButton = Array.from(els.artStyleButtons).find((button) => button.classList.contains('is-active'));
        const files = state.sourceFiles.filter(Boolean);
        if (!styleButton || !state.artStyle) {
          resetPreview('Choose a portrait style first.');
          els.artStyleGroup?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!files.length) {
          resetPreview('Upload a pet photo first.');
          root.querySelector('[data-upload]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (state.pets > 2) {
          resetPreview('Instant preview currently supports one or two pets.');
          return;
        }
        if (state.pets === 2 && files.length !== 1) {
          resetPreview('For a two-pet preview, upload one clear group photo containing both pets.');
          return;
        }

        resetPreview('');
        els.previewCreate.disabled = true;
        if (els.previewApply) els.previewApply.disabled = true;
        startPreviewProgress();
        try {
          const previewFile = await preparePreviewFile(files[0]);
          const sourceUrl = await uploadFile(previewFile, 'portrait-preview');
          const createRequestId = () => {
            const random = crypto.getRandomValues(new Uint32Array(4));
            return `web_${Date.now()}_${Array.from(random).map((value) => value.toString(16)).join('')}`;
          };
          const requestBody = {
            requestId: createRequestId(),
            sourceUrl,
            style: state.artStyle,
            petCount: state.pets,
            petName: els.previewName?.value || '',
            accessoryPolicy: els.previewAccessories?.value || 'keep_collar_no_tag',
            featurePolicy: els.previewFeatures?.checked === false ? 'soften' : 'preserve',
            modification: String(adjustment || '').trim()
          };
          let result;
          try {
            result = await waitForPreviewResult(requestBody);
          } catch (error) {
            const retryableProviderErrors = new Set([
              'preview_service_access_denied',
              'preview_service_busy',
              'preview_service_unavailable'
            ]);
            if (!retryableProviderErrors.has(String(error?.message || ''))) throw error;
            await new Promise((resolve) => setTimeout(resolve, 1400));
            result = await waitForPreviewResult({ ...requestBody, requestId: createRequestId() });
          }
          await drawPreview(result.sourceUrl, els.previewName?.value || '');
          state.preview = result;
          state.previewApproved = false;
          root.classList.add('amp-preview-ready');
          showWizardStep(4);
          stopPreviewProgress();
          els.previewLoading.hidden = true;
          els.previewResult.hidden = false;
          if (els.previewBackOptions) els.previewBackOptions.hidden = true;
          document.body.classList.add('amp-preview-is-reviewing');
        } catch (error) {
          stopPreviewProgress();
          els.previewLoading.hidden = true;
          const code = error?.name === 'AbortError' ? 'preview_timeout' : error.message;
          resetPreview(previewErrorMessage(code));
        } finally {
          els.previewCreate.disabled = false;
          if (els.previewApply) els.previewApply.disabled = false;
        }
      };

      els.previewCreate?.addEventListener('click', () => createPortraitPreview(''));
      const openSavedPreview = () => {
        if (!state.preview || !els.previewResult) return;
        showWizardStep(4);
        if (els.previewBackOptions) els.previewBackOptions.hidden = false;
        els.previewResult.hidden = false;
        document.body.classList.add('amp-preview-is-reviewing');
        els.previewResult.scrollTop = 0;
      };
      const closeSavedPreview = () => {
        if (els.previewResult) els.previewResult.hidden = true;
        document.body.classList.remove('amp-preview-is-reviewing');
        showWizardStep(5);
        els.orderPreview?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      els.viewPreview?.addEventListener('click', openSavedPreview);
      els.previewBackOptions?.addEventListener('click', closeSavedPreview);
      const chooseDesignerService = async () => {
        if (!state.preview) return;
        els.previewDesigner?.forEach((button) => {
          button.disabled = true;
          button.dataset.originalText = button.textContent;
          button.textContent = 'Saving your photo…';
        });
        try {
          await saveCurrentPreview();
          state.designerService = true;
          state.previewApproved = false;
          syncOrderPreview();
          root.classList.add('amp-preview-approved');
          els.orderConfig?.forEach((element) => { element.hidden = false; });
          showWizardStep(5);
          if (els.previewResult) els.previewResult.hidden = true;
          if (els.previewDialog?.open) els.previewDialog.close();
          document.body.classList.remove('amp-preview-is-reviewing');
          els.previewMessage.textContent = 'Professional designer selected. Choose a canvas and complete checkout. After payment, your proof will be emailed within 24 hours and nothing prints until you approve it.';
          els.orderPreview?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (_error) {
          els.previewMessage.textContent = 'We could not save your photo for the designer. Please try again.';
        } finally {
          els.previewDesigner?.forEach((button) => {
            button.disabled = false;
            button.textContent = button.dataset.originalText || 'Continue with a professional designer';
            delete button.dataset.originalText;
          });
        }
      };
      els.previewDesigner?.forEach((button) => button.addEventListener('click', chooseDesignerService));
      els.previewApprove?.addEventListener('click', async () => {
        if (!state.preview) return;
        els.previewApprove.disabled = true;
        els.previewApprove.textContent = 'Saving this direction…';
        try {
          await saveCurrentPreview();
          state.designerService = false;
          state.previewApproved = true;
          syncOrderPreview();
          root.classList.add('amp-preview-approved');
          els.orderConfig?.forEach((element) => { element.hidden = false; });
          showWizardStep(5);
          els.previewResult.hidden = true;
          document.body.classList.remove('amp-preview-is-reviewing');
          els.previewApprove.classList.add('is-approved');
          els.previewApprove.textContent = '✓ Preview selected for this order';
          els.previewMessage.textContent = 'Saved. Now choose canvas or acrylic, then select the finish and size for this exact artwork.';
          els.orderPreview?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (_error) {
          state.previewApproved = false;
          els.previewApprove.textContent = 'Yes — I love it';
          els.previewMessage.textContent = 'We could not save this direction. Please try approving it again.';
        } finally {
          els.previewApprove.disabled = false;
        }
      });
      els.previewRevise?.addEventListener('click', () => els.previewDialog?.showModal());
      els.previewClose?.addEventListener('click', () => els.previewDialog?.close());
      els.previewRetry?.addEventListener('click', () => {
        els.previewDialog?.close();
        createPortraitPreview('');
      });
      els.previewChangeStyle?.addEventListener('click', () => {
        els.previewDialog?.close();
        resetPreview('Choose a style and create a new preview.');
        openStylePicker();
      });
      els.previewUploadNew?.addEventListener('click', () => {
        els.previewDialog?.close();
        els.fileInput?.click();
      });
      els.previewApply?.addEventListener('click', () => {
        const adjustment = els.previewAdjustment?.value || '';
        if (!adjustment.trim()) {
          els.previewAdjustment?.focus();
          return;
        }
        els.previewDialog?.close();
        createPortraitPreview(adjustment);
      });

      const handleFiles = async (files) => {
        const selected = Array.from(files || []).slice(0, 1);
        const entries = [];
        showWizardStep(1);
        state.sourceFiles = selected;
        setPhotoState(selected.length > 0);
        resetPreview(selected.length ? 'Photo changed — create a new preview when the upload is ready.' : '');
        if (els.photoContinue) els.photoContinue.hidden = true;
        state.uploadedUrls = [];
        els.uploadList.innerHTML = '';
        els.fileLabel.textContent = selected.length ? text('selected', '{count} selected').replace('{count}', selected.length) : text('noFileChosen', 'No file chosen');
        if (!selected.length) {
          refresh();
          return;
        }
        els.uploadProgress.hidden = false;
        if (els.uploadProgressFill) els.uploadProgressFill.style.width = '0%';
        if (els.uploadPercent) els.uploadPercent.textContent = '0%';
        if (els.uploadMeter) els.uploadMeter.setAttribute('aria-valuenow', '0');
        if (els.uploadProgressLabel) els.uploadProgressLabel.textContent = 'Preparing secure upload…';
        els.uploadStatus.textContent = '';

        const activeEntries = () => entries.filter((entry) => !entry.removed);
        const updateFileLabel = () => {
          const count = activeEntries().length;
          els.fileLabel.textContent = count ? text('selected', '{count} selected').replace('{count}', count) : text('noFileChosen', 'No file chosen');
        };
        const updateProgress = () => {
          const active = activeEntries();
          const percent = active.length
            ? Math.round(active.reduce((sum, entry) => sum + Number(entry.progress || 0), 0) / active.length)
            : 0;
          if (els.uploadProgressFill) els.uploadProgressFill.style.width = `${percent}%`;
          if (els.uploadPercent) els.uploadPercent.textContent = `${percent}%`;
          if (els.uploadMeter) els.uploadMeter.setAttribute('aria-valuenow', String(percent));
          if (els.uploadProgressLabel) {
            const preparing = active.some((entry) => entry.phase === 'preparing');
            els.uploadProgressLabel.textContent = percent >= 100
              ? 'Photo upload complete'
              : preparing
                ? 'Preparing secure upload…'
                : 'Uploading your photo securely…';
          }
        };
        const removeEntry = (entry) => {
          entry.removed = true;
          if (entry.previewUrl) URL.revokeObjectURL(entry.previewUrl);
          if (entry.url) state.uploadedUrls = state.uploadedUrls.filter((url) => url !== entry.url);
          entry.item.remove();
          state.sourceFiles = activeEntries().map((active) => active.file);
          if (!state.sourceFiles.length) els.fileInput.value = '';
          setPhotoState(state.sourceFiles.length > 0);
          resetPreview(state.sourceFiles.length ? 'Photo changed — create a new preview when ready.' : 'Upload a pet photo to create a preview.');
          updateFileLabel();
          updateProgress();
          refresh();
        };
        const uploadEntry = async (entry) => {
          entry.complete = false;
          entry.progress = 0;
          entry.phase = 'preparing';
          entry.retry.hidden = true;
          entry.state.textContent = 'Preparing…';
          entry.warning.textContent = '';
          els.uploadProgress.hidden = false;
          updateProgress();
          if (entry.file.size > config.maxFileBytes) {
            entry.complete = true;
            entry.state.textContent = text('notUploaded', 'Not uploaded');
            entry.warning.textContent = text('overSize', '{filename} is over 25MB.').replace('{filename}', entry.file.name);
            updateProgress();
            return;
          }
          entry.warning.textContent = await inspectResolution(entry.file, entry.previewUrl);
          try {
            const url = await uploadFile(entry.file, 'order-photo', ({ phase, percent }) => {
              if (entry.removed) return;
              entry.phase = phase;
              entry.progress = percent;
              entry.state.textContent = phase === 'preparing'
                ? 'Preparing…'
                : phase === 'complete'
                  ? text('uploaded', 'Uploaded')
                  : `Uploading… ${percent}%`;
              updateProgress();
            });
            if (entry.removed) return;
            entry.url = url;
            entry.progress = 100;
            entry.phase = 'complete';
            state.uploadedUrls.push(url);
            entry.state.textContent = text('uploaded', 'Uploaded');
          } catch (error) {
            if (entry.removed) return;
            entry.state.textContent = text('notUploaded', 'Not uploaded');
            entry.retry.hidden = false;
            els.uploadStatus.textContent = error.message;
          } finally {
            entry.complete = true;
            updateProgress();
            refresh();
          }
        };

        for (const file of selected) {
          const previewUrl = file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : '';
          if (previewUrl && els.previewSource) els.previewSource.src = previewUrl;
          const item = document.createElement('div');
          item.className = 'amp-upload__file';
          const thumb = document.createElement('img');
          thumb.className = 'amp-upload__thumb';
          thumb.alt = '';
          if (previewUrl) thumb.src = previewUrl;
          const meta = document.createElement('div');
          meta.className = 'amp-upload__meta';
          const name = document.createElement('span');
          name.className = 'amp-upload__name';
          name.textContent = file.name;
          const stateLabel = document.createElement('span');
          stateLabel.className = 'amp-upload__state';
          stateLabel.textContent = text('waiting', 'Waiting');
          const warning = document.createElement('span');
          warning.className = 'amp-upload__warning';
          meta.append(name, stateLabel, warning);
          const actions = document.createElement('div');
          actions.className = 'amp-upload__actions';
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'amp-upload__action';
          retry.textContent = text('retry', 'Retry');
          retry.hidden = true;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'amp-upload__action';
          remove.textContent = text('remove', 'Remove');
          actions.append(retry, remove);
          item.append(thumb, meta, actions);
          els.uploadList.append(item);
          const entry = { file, item, state: stateLabel, warning, retry, previewUrl, url: '', removed: false, complete: false, progress: 0, phase: 'waiting' };
          retry.addEventListener('click', () => uploadEntry(entry));
          remove.addEventListener('click', () => removeEntry(entry));
          entries.push(entry);
          uploadEntry(entry);
        }
        await Promise.all(entries.map((entry) => new Promise((resolve) => {
          const check = () => entry.complete || entry.removed ? resolve() : setTimeout(check, 100);
          check();
        })));
        if (activeEntries().length === 0) {
          els.uploadProgress.hidden = true;
        }
        if (state.uploadedUrls.length) {
          els.uploadStatus.textContent = '✓ Photo uploaded. Next, choose the art style you love.';
          if (els.previewMessage) els.previewMessage.textContent = '';
          if (els.photoContinue) els.photoContinue.hidden = false;
          setPhotoState(true, { reveal: true });
        }
        refresh();
      };

      els.thumbs.forEach((button) => {
        button.addEventListener('click', () => {
          if (!els.mainImage) return;
          els.mainImage.src = button.dataset.gallerySrc;
          els.mainImage.alt = button.dataset.galleryAlt || '';
          els.thumbs.forEach((thumb) => {
            const active = thumb === button;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      function updateArtStyleArrows() {
        if (!els.artStyleScroller) return;
        const maxScroll = Math.max(0, els.artStyleScroller.scrollWidth - els.artStyleScroller.clientWidth);
        if (els.artStylePrev) els.artStylePrev.disabled = els.artStyleScroller.scrollLeft <= 2;
        if (els.artStyleNext) els.artStyleNext.disabled = els.artStyleScroller.scrollLeft >= maxScroll - 2;
      }
      function scrollArtStyles(direction) {
        if (!els.artStyleScroller) return;
        const firstCard = els.artStyleButtons[0];
        const distance = (firstCard?.getBoundingClientRect().width || els.artStyleScroller.clientWidth * .4) + 8;
        els.artStyleScroller.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }
      els.artStylePrev?.addEventListener('click', () => scrollArtStyles(-1));
      els.artStyleNext?.addEventListener('click', () => scrollArtStyles(1));
      els.artStyleBackdrop?.addEventListener('click', () => closeStylePicker());
      els.artStyleClose?.addEventListener('click', () => closeStylePicker());
      els.artStyleScroller?.addEventListener('scroll', updateArtStyleArrows, { passive: true });
      window.addEventListener('resize', updateArtStyleArrows, { passive: true });
      requestAnimationFrame(updateArtStyleArrows);

      let styleAdvanceTimer = null;
      els.artStyleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const styleChanged = state.artStyle && state.artStyle !== button.dataset.artStyleOption;
          state.artStyle = button.dataset.artStyleOption;
          if (els.artStyleNote) {
            els.artStyleNote.textContent = button.dataset.artStyleNote || `${state.artStyle} selected.`;
          }
          if (styleChanged && state.preview) resetPreview('Style changed — create a fresh preview to see this direction.');
          showError('');
          refresh();
          if (els.styleContinue) els.styleContinue.textContent = `Continue with ${state.artStyle} →`;
          window.clearTimeout(styleAdvanceTimer);
          styleAdvanceTimer = window.setTimeout(() => showWizardStep(3), 220);
        });
      });

      els.photoContinue?.addEventListener('click', () => showWizardStep(2));
      els.styleContinue?.addEventListener('click', () => showWizardStep(3));
      els.wizardBack.forEach((button) => {
        button.addEventListener('click', () => showWizardStep(button.dataset.wizardBack, { scroll: true }));
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !document.body.classList.contains('amp-wizard-dialog-is-open')) return;
        if (state.wizardStep === 3) showWizardStep(2);
        else if (state.wizardStep === 2) showWizardStep(1, { scroll: true });
      });
      els.nameChoices.forEach((button) => {
        button.addEventListener('click', () => {
          state.nameMode = button.dataset.nameChoice === 'name' ? 'name' : 'none';
          els.nameChoices.forEach((choice) => {
            const active = choice === button;
            choice.classList.toggle('is-active', active);
            choice.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          if (els.nameField) els.nameField.hidden = state.nameMode !== 'name';
          if (state.nameMode === 'none' && els.previewName) els.previewName.value = '';
          if (state.nameMode === 'name') window.setTimeout(() => els.previewName?.focus(), 80);
          if (state.preview) resetPreview('Preview settings changed — create a fresh preview.');
        });
      });

      els.styleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          state.style = canonicalFormat(button.dataset.styleOption);
          refresh();
        });
      });

      els.orderMaterialButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          state.material = button.dataset.orderMaterial;
          state.style = formatFromSelections(state);
          refresh();
        });
      });

      els.orderCanvasFinishButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          state.canvasFinish = button.dataset.orderCanvasFinish;
          state.style = formatFromSelections(state);
          refresh();
        });
      });

      els.orderCanvasColorButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          state.canvasColor = button.dataset.orderCanvasColor;
          state.style = formatFromSelections(state);
          refresh();
        });
      });

      els.orderAcrylicColorButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          state.acrylicColor = button.dataset.orderAcrylicColor;
          state.style = formatFromSelections(state);
          refresh();
        });
      });

      els.secondOpen?.addEventListener('click', () => openSecondDialog({ reset: !state.secondPortrait?.approved }));
      els.secondEdit?.addEventListener('click', () => openSecondDialog({ reset: true }));
      els.secondClose?.addEventListener('click', () => els.secondDialog?.close());
      els.secondDialog?.addEventListener('cancel', () => {
        clearInterval(secondPreviewProgressTimer);
        secondPreviewProgressTimer = null;
      });
      els.secondFile?.addEventListener('change', () => {
        const file = els.secondFile.files?.[0];
        setSecondError('');
        if (secondSourceObjectUrl) URL.revokeObjectURL(secondSourceObjectUrl);
        secondSourceObjectUrl = '';
        if (!file) {
          if (els.secondFileCard) els.secondFileCard.hidden = true;
          if (els.secondCreate) els.secondCreate.disabled = true;
          return;
        }
        if (file.size > Number(config.maxFileBytes || 26214400)) {
          setSecondError('This photo is larger than 25 MB. Choose a smaller file.');
          els.secondFile.value = '';
          if (els.secondFileCard) els.secondFileCard.hidden = true;
          if (els.secondCreate) els.secondCreate.disabled = true;
          return;
        }
        secondSourceObjectUrl = URL.createObjectURL(file);
        if (els.secondFilePreview) els.secondFilePreview.src = secondSourceObjectUrl;
        if (els.secondFileName) els.secondFileName.textContent = file.name;
        if (els.secondFileCard) els.secondFileCard.hidden = false;
        if (els.secondCreate) els.secondCreate.disabled = false;
      });
      els.secondCreate?.addEventListener('click', createSecondPortraitPreview);
      els.secondApprove?.addEventListener('click', approveSecondPortrait);
      els.secondRetry?.addEventListener('click', () => resetSecondComposer());
      els.secondRemove?.addEventListener('click', () => {
        state.secondPortrait = null;
        resetSecondComposer();
        refresh();
      });

      els.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          state.size = button.dataset.sizeOption;
          refresh();
        });
      });

      els.petButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const previousPets = state.pets;
          state.pets = Math.min(4, Math.max(1, Number(button.dataset.petCount)));
          if (previousPets !== state.pets && state.preview) resetPreview('Pet count changed — create a fresh preview.');
          refresh();
        });
      });

      els.rushToggle.addEventListener('change', () => {
        state.rush = els.rushToggle.checked;
        refresh();
      });

      els.uploadLater.addEventListener('change', () => {
        state.uploadLater = els.uploadLater.checked;
        if (state.uploadLater) {
          state.uploadedUrls = [];
          state.sourceFiles = [];
          els.fileInput.value = '';
          els.fileLabel.textContent = text('noFileChosen', 'No file chosen');
          els.uploadList.innerHTML = '';
          els.uploadStatus.textContent = text('uploadLaterStatus', 'No problem. We will collect your photo after checkout.');
          resetPreview('Upload a pet photo to create a free preview.');
        } else {
          els.uploadStatus.textContent = text('uploadHelp', 'One clear front-facing photo works best. Good lighting helps create a more accurate preview.');
        }
        refresh();
      });

      els.fileInput.addEventListener('change', () => {
        state.uploadLater = false;
        els.uploadLater.checked = false;
        handleFiles(els.fileInput.files);
      });

      els.uploadStartButton?.addEventListener('click', () => {
        if (!state.sourceFiles.length) {
          els.fileInput?.click();
          return;
        }
        setPhotoState(true);
      });

      if (els.uploadDropzone) {
        ['dragenter', 'dragover'].forEach((eventName) => {
          els.uploadDropzone.addEventListener(eventName, (event) => {
            event.preventDefault();
            els.uploadDropzone.classList.add('is-dragging');
          });
        });
        ['dragleave', 'drop'].forEach((eventName) => {
          els.uploadDropzone.addEventListener(eventName, (event) => {
            event.preventDefault();
            els.uploadDropzone.classList.remove('is-dragging');
          });
        });
        els.uploadDropzone.addEventListener('drop', (event) => {
          const files = Array.from(event.dataTransfer?.files || []).slice(0, 1);
          if (!files.length) return;
          state.uploadLater = false;
          els.uploadLater.checked = false;
          handleFiles(files);
        });
      }

      [els.previewName, els.previewAccessories, els.previewFeatures].forEach((input) => {
        input?.addEventListener('change', () => {
          if (state.preview) resetPreview('Preview settings changed — create a fresh preview.');
        });
      });

      if (els.mobileAdd) {
        els.mobileAdd.addEventListener('click', () => {
          if (els.mobileAdd.getAttribute('aria-disabled') === 'true') return;
          if (typeof els.form.requestSubmit === 'function') {
            els.form.requestSubmit(els.submit);
          } else {
            els.submit.click();
          }
        });
      }

      els.form.addEventListener('submit', async (event) => {
        event.preventDefault();
        showError('');
        if (!state.artStyle) {
          showError('Choose a portrait style before adding your portrait to the cart.');
          els.artStyleGroup?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          els.artStyleButtons[0]?.focus();
          return;
        }
        if ((!state.previewApproved && !state.designerService) || !state.preview?.referenceUrl) {
          showError('Approve your preview or choose the professional designer option before adding a physical format to the cart.');
          root.querySelector('[data-portrait-preview]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        const variant = findVariant();
        if (!variant) {
          showError(text('optionUnavailable', 'This option is unavailable.'));
          return;
        }
        const secondVariant = findSecondVariant();
        if (state.secondPortrait?.approved && (!secondVariant || !state.secondPortrait.referenceUrl || !state.secondPortrait.originalUrl)) {
          showError('The second portrait is not fully saved yet. Open it and approve the preview again.');
          els.secondCard?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!state.uploadedUrls.length) {
          showError('Your original pet photo is still uploading. Please wait a moment and try again.');
          return;
        }
        if (state.pets > 1 && !config.extraPetVariantId) {
          showError(text('extraPetMissing', 'Extra pet add-on is not configured.'));
          return;
        }
        if (state.rush && !config.rushVariantId) {
          showError(text('rushMissing', 'Rush service is not configured.'));
          return;
        }

        const group = `portrait-${Date.now()}`;
        const properties = {
          'Portrait style': state.artStyle,
          'Portrait format': state.style,
          'Portrait size': state.size,
          'Digital copy included': 'Yes',
          'Number of pets': String(state.pets),
          '_bundle_group': group
        };
        const petName = String(els.previewName?.value || '').trim();
        if (petName) properties['Pet name'] = petName.slice(0, 40);
        if (state.preview?.referenceUrl) {
          properties['_portrait_preview_id'] = state.preview.previewId;
          properties['_portrait_preview_file'] = state.preview.referenceUrl;
          properties['_portrait_preview_style'] = state.preview.style;
          properties['_portrait_preview_note'] = state.preview.modification || '';
          properties['_portrait_preview_approved'] = state.previewApproved ? 'yes' : 'no';
          properties['_accessory_preference'] = els.previewAccessories?.value || 'keep_collar_no_tag';
          properties['_feature_preference'] = els.previewFeatures?.checked === false ? 'soften' : 'preserve';
        }
        if (state.designerService) {
          properties['Artwork service'] = 'Professional designer proof within 24 hours after payment';
          properties['_designer_proof_required'] = 'yes';
          properties['_designer_status'] = 'awaiting_paid_order';
        } else {
          properties['Artwork service'] = 'Customer-approved instant preview';
        }
        if (state.uploadLater) {
          properties['_photo_upload'] = 'pending';
        } else {
          state.uploadedUrls.slice(0, 4).forEach((url, index) => {
            properties[`_pet_photo_${index + 1}`] = url;
          });
        }

        const items = [{ id: Number(variant.id), quantity: 1, properties }];
        if (state.secondPortrait?.approved && secondVariant) {
          const secondProperties = {
            'Portrait style': state.artStyle,
            'Portrait format': state.style,
            'Portrait size': state.size,
            'Digital copy included': 'Yes',
            'Second portrait offer': '40% off with a full-price portrait',
            '_linked_to': group,
            '_addon': 'second_portrait_40_off',
            '_pet_photo_1': state.secondPortrait.originalUrl,
            '_portrait_preview_file': state.secondPortrait.referenceUrl,
            '_portrait_preview_id': state.secondPortrait.preview?.previewId || '',
            '_portrait_preview_approved': 'yes'
          };
          if (state.secondPortrait.name) secondProperties['Pet name'] = state.secondPortrait.name;
          items.push({ id: Number(secondVariant.id), quantity: 1, properties: secondProperties });
        }
        if (state.pets > 1) {
          items.push({
            id: Number(config.extraPetVariantId),
            quantity: state.pets - 1,
            properties: { '_linked_to': group, '_addon': 'extra_pet' }
          });
        }
        if (state.rush) {
          items.push({
            id: Number(config.rushVariantId),
            quantity: 1,
            properties: { '_linked_to': group, '_addon': 'rush_service' }
          });
        }

        els.submit.setAttribute('aria-disabled', 'true');
        els.submit.classList.add('loading');
        els.mobileAdd?.setAttribute('aria-disabled', 'true');
        const spinner = els.submit.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        try {
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          const parsed = await response.json();
          if (!response.ok || parsed.status) throw new Error(parsed.description || parsed.message || text('addFailed', 'Could not add this item.'));
          if (!parsed.key && Array.isArray(parsed.items) && parsed.items.length) {
            parsed.key = parsed.items[0].key;
          }
          if (cart && typeof cart.renderContents === 'function' && parsed.sections) {
            cart.renderContents(parsed);
          } else {
            window.location.href = routes.cart_url;
          }
        } catch (error) {
          showError(error.message || text('addFailed', 'Could not add this item.'));
        } finally {
          els.submit.classList.remove('loading');
          els.submit.removeAttribute('aria-disabled');
          els.mobileAdd?.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      });

      setPhotoState(false);
      updateFlowStep(1);
      refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
